import { Theme } from '@emotion/react';

export const generateContactSupportStyles = (theme: Theme) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '48px auto 68px',
    },
    title: {
        fontFamily: theme.palette.common.font,
        fontStyle: 'normal',
        color: theme.palette.common.black,
        marginBottom: '30px',
        fontWeight: 500,
        fontSize: '24px',
        lineHeight: '100%',
        letterSpacing: '0.25px',
    },
});
